import React, { FC } from 'react';
import { Button, PageHeader } from '@ui';
import AnalyticsStatus from '@app/components/ui/analytics-status/analytics-status';
import { MonitoringFormInfoType } from '@app/interfaces/qm-module/qm-manage/qm-monitoring-forms.type';
import useTranslation from '@app/hooks/use-translation';
import { useChangeMonitoringFormStatusMutation } from '@app/store/api/qm-module/qm-manage/qm-manage-monitoring-forms.api';

type MonitoringFormsSettingsHeaderWithStatusesPropsType = {
  monitoringFormData: MonitoringFormInfoType | undefined;
};
const MonitoringFormsSettingsHeaderWithStatuses: FC<
  MonitoringFormsSettingsHeaderWithStatusesPropsType
> = (props) => {
  const { monitoringFormData } = props;
  const { t } = useTranslation('pages.qmManage.monitoring_forms');

  const [changeMfStatus] = useChangeMonitoringFormStatusMutation();

  function handleStartMF() {
    if (!monitoringFormData) return;
    changeMfStatus({ id: monitoringFormData?.id, status: 'ACTIVE' });
  }

  return (
    <PageHeader
      popLink={`./..`}
      label={
        <div className="flex items-center gap-[10px]">
          <div className="mt-[-2px] font-[600]">{monitoringFormData?.name}</div>
          <AnalyticsStatus status={monitoringFormData?.status || 'NEW'} />
        </div>
      }
    >
      {monitoringFormData?.status === 'NEW' && (
        <Button
          icon="TriangleRightIcon"
          sizeIcon={15}
          fill="outlined"
          onClick={() => handleStartMF()}
          label={t('start_project')}
        />
      )}
    </PageHeader>
  );
};

export default MonitoringFormsSettingsHeaderWithStatuses;
